<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/services">Services</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Asset Management and Support
              </li>
            </ol>
          </nav>

          <div class="row">
            <div class="col-lg-8">
              <h2 class="title">Asset Management and Support</h2>
              <p class="lead">
                Ensuring optimal operations and performance for IT investments
                requires a strong asset maintenance lifecycle strategy. However,
                some problems associated with poor asset maintenance are: poor
                support for products but not for complete solutions, current
                decisions are taken, and recommendations are given without the
                knowledge of customer environments, lack of SLA commit ment s,
                inad equat e change-management coord inat ion hence, making
                managing maintenance contracts thus becomes a daunting
                task—especially for enterprises with hundreds or thousands of
                devices purchased from multiple resellers.
              </p>
              <p class="lead">
                Our company's Asset Management offering is added to every
                maintenance engagement, eliminating the need for internal
                resources allocated for contract management.
              </p>

              <p class="lead">
                Customers are provided with a dedicated consultant to manage:
              
              </p>

              <ul class="lead">
                <li>Reviewing the process of inventory and maintenance
                management</li>
                <li>Analyzing inventory reports </li>
                <li>Recommending appropriate service levels based on specific
                environments</li>
                <li>Developing long term plans to address
                additions, changes and credits based on a real-time reporting</li>
              </ul>

              <p class="lead">
                We help to eliminate waste and align maintenance support
                provided by hardware and software vendors with customer needs.
              </p>
            </div>

            <div class="col-lg-4">
              <ServicesSideNav></ServicesSideNav>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import ServicesSideNav from "./ServicesSideNav";
export default {
  name: "cloud overview",
  components: {
    ServicesSideNav,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
